import { DataTableSearchService } from "aes-datatables";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { SenetData } from "aes-datatables";
import { Injectable } from "@angular/core";
import { CRUDService, Message } from "aes-common";

export interface User {
    username: string;
    email: string;
    creationDate: string;
    defaultConnectionId: number;
    connectionType: string;
    passwordEnc: string;
    role: string;
    acctId: number;
}
@Injectable()
export class AESUserService implements DataTableSearchService<User>, CRUDService<User>{

    constructor(private http: HttpClient) { }

    create(object: User): Observable<Message> {
        const href = 'users';
        var requestUrl = `${href}`

        return this.http.post<Message>(requestUrl, object);
    }
    edit(object: User): Observable<Message> {
        const href = 'users';
        var requestUrl = `${href}`

        return this.http.put<Message>(requestUrl, object);
    }
    delete(object: User): Observable<Message> {
        const href = 'users';
        var params = new HttpParams().set("username", object.username);
        var requestUrl = `${href}`

        return this.http.delete<Message>(requestUrl, {
            params: params
        });
    }

    search(sort: string, order: string, page: number, search: string, limit: number, customFilter: any): Observable<SenetData<User>> {
        const href = 'users';
        var offset = page * limit;
        var requestUrl = `${href}`;
        var params = new HttpParams();
        if(sort != undefined && sort != ""){
            params = params.set("sort", sort);
        }
        if(!isNaN(limit)){
            params = params.set("limit", limit.toString());
        }
        if(order != undefined){
            params = params.set("sortDir", order);          
        }
        if(!isNaN(offset)){
            params = params.set("offset", offset.toString());
        }
        if (search != undefined && search != "") {
            params = params.set("search", search);
        }

        if (customFilter != undefined && customFilter.acctId != undefined) {
            params = params.set("acctId", customFilter.acctId);
        }
        return this.http.get<SenetData<User>>(requestUrl, {
            params : params
        });
    }
}